// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SU_gwyHSECBcpa {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.kftQ6q8ACJQVqh {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  padding: 4px 10px 36px 10px;
  transition: padding 0.2s ease-in-out;
  background: var(--ds-surface, #ffffff);
}
.kftQ6q8ACJQVqh.PEoeHdgNW9sCrD {
  bottom: 64px;
}
.AKS94H6VrF8Hzd {
  position: relative;
  flex: 1 0;
  margin: 0 6px;
  overflow: hidden;
  transition: flex 0.2s ease-in-out, min-width 0.2s ease-in-out, margin 0.2s ease-in-out, border-radius 0.2s ease-in-out, padding 0.2s ease-in-out, opacity 0.2s ease-in;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 16px;
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  -webkit-backdrop-filter: blur(0);
          backdrop-filter: blur(0);
}
.kftQ6q8ACJQVqh.iYel4UtpFJPvFG {
  padding: 0;
}
.kftQ6q8ACJQVqh.iYel4UtpFJPvFG .AKS94H6VrF8Hzd {
  flex-grow: 1;
  min-width: auto;
  margin: 0;
  border: unset;
  border-radius: 0;
}
.kftQ6q8ACJQVqh .AKS94H6VrF8Hzd.aSqne5434RoAtc {
  flex: 0 1 0px;
  min-width: 0;
  margin: 0;
  opacity: 0;
}
.mCrfqpQSvEd6E_ {
  position: relative;
  z-index: 1;
  height: 100%;
}
.rVScOo9fTPQTsj {
  flex: 0 0 272px;
}
.RuYp8xIEaKN48D,
.c_qCPgKqCHyZfF {
  flex: 1 0;
  min-width: 400px;
}
.c_qCPgKqCHyZfF.aSqne5434RoAtc {
  border: none;
}
@media print {
  .SU_gwyHSECBcpa {
    position: relative;
  }
  .kftQ6q8ACJQVqh {
    position: relative;
    flex-direction: column;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manager": `SU_gwyHSECBcpa`,
	"splitscreen": `kftQ6q8ACJQVqh`,
	"tabs": `PEoeHdgNW9sCrD`,
	"panel": `AKS94H6VrF8Hzd`,
	"single": `iYel4UtpFJPvFG`,
	"hidden": `aSqne5434RoAtc`,
	"content": `mCrfqpQSvEd6E_`,
	"inbox": `rVScOo9fTPQTsj`,
	"board": `RuYp8xIEaKN48D`,
	"planner": `c_qCPgKqCHyZfF`
};
export default ___CSS_LOADER_EXPORT___;
